import $ from "jquery";
import GTM from './google-tag-manager.config';

export default (() => {
    if (process.env.NODE_ENV === 'production') {
        $('head').append(GTM.script);
        $('body').prepend(GTM.noscript);
    }
})();
